import { useCallback } from "react";

/**
 * useMagneticCursor
 * Returns an onMouseMove handler that writes pointer coordinates into
 * CSS variables --x, --y on the target — used by `.magnetic-btn` class.
 */
export function useMagneticCursor() {
  return useCallback((e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    el.style.setProperty("--x", `${x}%`);
    el.style.setProperty("--y", `${y}%`);
  }, []);
}
